define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PermitLicItemDef = void 0;
    class PermitLicItemDef extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "PermitType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitSubtype", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "PermitSubtypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ItemType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ItemTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Description", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DescriptionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsActive", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsActiveError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, PermitLicItemDef.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.PermitType = (0, EntityUtil_1.toInt)(entity.PermitType);
            a.PermitSubtype = (0, EntityUtil_1.toInt)(entity.PermitSubtype);
            a.ItemType = (0, EntityUtil_1.toInt)(entity.ItemType);
            a.Description = b.Description;
            a.IsActive = (0, EntityUtil_1.toInt)(entity.IsActive);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, PermitLicItemDef.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "IsActive", "Is Active? ");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                PermitType: this.PermitType,
                PermitSubtype: this.PermitSubtype,
                ItemType: this.ItemType,
                Description: this.Description,
                IsActive: this.IsActive,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
    }
    exports.PermitLicItemDef = PermitLicItemDef;
    Object.defineProperty(PermitLicItemDef, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "PermitLicItemDef"
    });
    Object.defineProperty(PermitLicItemDef, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "License Item"
    });
    Object.defineProperty(PermitLicItemDef, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "PermitType", "PermitSubtype", "ItemType", "Description", "IsActive"]
    });
    Object.defineProperty(PermitLicItemDef, "PermitTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitLicItemDef, "PermitSubtypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitLicItemDef, "ItemTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(PermitLicItemDef, "ItemTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitLicItemDef, "DescriptionLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 256
    });
    Object.defineProperty(PermitLicItemDef, "DescriptionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(PermitLicItemDef, "IsActiveReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItemDef.prototype, "PermitType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItemDef.prototype, "PermitTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItemDef.prototype, "PermitSubtype", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItemDef.prototype, "PermitSubtypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItemDef.prototype, "ItemType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItemDef.prototype, "ItemTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItemDef.prototype, "Description", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItemDef.prototype, "DescriptionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItemDef.prototype, "IsActive", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], PermitLicItemDef.prototype, "IsActiveError", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], PermitLicItemDef.prototype, "merge", null);
});
